var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('YearSelector',{on:{"select":_vm.select}}),_c('Monthly',{staticClass:"my-3",attrs:{"items":_vm.monthly,"year":_vm.year}}),_c('Generate',{staticClass:"my-3",attrs:{"year":_vm.year},on:{"refresh":_vm.select}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }